"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Lifted intrinsic React components that accept observable props.
 *
 * @module
 */

var React = require("react");

var react_1 = require("./react");

function liftIntrinsic(intrinsicClassName) {
  return function (props) {
    return React.createElement(react_1.LiftWrapper, {
      component: intrinsicClassName,
      props: props
    });
  };
}

exports.liftIntrinsic = liftIntrinsic;

function createLiftedIntrinsics() {
  var html = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr'];
  var r = {};
  html.forEach(function (e) {
    return r[e] = liftIntrinsic(e);
  });

  r.Fragment = function (props) {
    return React.createElement(react_1.LiftWrapper, {
      component: React.Fragment,
      props: props
    });
  };

  return r;
}

exports.createLiftedIntrinsics = createLiftedIntrinsics; // @TODO SVG support